/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-12 15:40:50                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-25 16:02:48                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Services
  * DetailsDrawer: display details drawer
*/

/* Imports */
import { Button, Card, CardBody, CardFooter, Typography } from "@material-tailwind/react";
import { Modal } from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";
import { DocumentDuplicateIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { t } from "i18next";
/***/

/* Components */
/***/

/* Services */
import { api } from "../../../../../services/api/api";
/***/

import "./PlanningModal.scss";
import Loading from "../../../../../components/loading/Loading";
import Switch from "../../../../../components/switch/Switch";

/**
* DetailsDrawer: display details drawer
* @param time - time to display
* @param onUpdate - on update callback, return updated time
*/
export default function DuplicateWorkorderModal({
  open,
  workorder,
  onUpdate,
  onClose
}: {
  open: boolean,
  workorder: EasyTech.Workorder,
  onUpdate: (workorder: EasyTech.Workorder) => void
  onClose: () => void
}) {
  const [dupliLoad, setDupliLoad] = useState<boolean>(false); 
  const [withTech, setWithTech] = useState<boolean>(false); 
  const [withSchedule, setWithSchedule] = useState<boolean>(false); 
  
  const duplicateWo = () => {
    setDupliLoad(true);
    api.get("users/workorders/"+workorder.id)
      .then((ret) => {
        const result = ret as EasyTech.Workorder;
        result.compInfos?.inputs.forEach((input) => {
          delete input.id;
          return {...input};
        });
        result.compInfos?.selects.forEach((input) => {
          delete input.id;
          return {...input};
        });
        const wo = {
          ...result,
          technician: withTech ? result.technician : undefined,
          schedule: withSchedule ? result.schedule : undefined
        };
        api.post("admin/workorders", wo)
          .then((ret) => {
            toast.success(t("workorder:duplicate:success"));
            onUpdate(ret as EasyTech.Workorder);
          }).catch((err) => {
            console.error("Erreur", err);
            toast.error(t("workorder:duplicate:error"));
          }).finally(() => {
            setDupliLoad(false);
            onClose();
          });
      })
      .catch(() => {
        toast.error(t("workorder:notfound:error"));
        setDupliLoad(false);
        onClose();
      });
  };
  
  return(
    <Modal
      open={open}
      onClose={onClose}
      className="te-modal"
      aria-labelledby="te-modal"
      aria-describedby="te-modal">
      <Card className="te-modal-content  rounded-lg">
        <button className="close-button" onClick={() => onClose()}>
          <XMarkIcon className="w-4"/>
        </button>
        <CardBody>
          <div  className="flex items-center gap-3 mb-5">
            <div className="rounded-full border p-2 bg-light-green-200">          
              <DocumentDuplicateIcon className="w-7 text-green-700"  />
            </div>
            <Typography variant="h5">
              {t("admin:interventions:duplicate:title", { ref: workorder.ref })}
            </Typography>
          </div>

          <Typography variant="paragraph">
            {t("admin:interventions:duplicate:description")}
          </Typography>

          <div className="field flex flex-row items-center gap-2">
            <div className="flex flex-col">
              <label>{t("Add technician")}</label>
  
              <span className="text-sm text-gray-500 mt-1">
                {t("Duplicated intervention will also copy the technician.")}
              </span>
            </div>
  
            <Switch checked={withTech}
                    onChange={(e: boolean) => setWithTech(e)}/>
          </div>

          <div className="field flex flex-row items-center gap-2">
            <div className="flex flex-col">
              <label>{t("Add schedule")}</label>
  
              <span className="text-sm text-gray-500 mt-1">
                {t("Duplicated intervention will also copy the sheduled date.")}
              </span>
            </div>
  
            <Switch checked={withSchedule}
                    onChange={(e: boolean) => setWithSchedule(e)}/>
          </div>
        </CardBody>
        <CardFooter className="pt-0 flex gap-2 justify-end">
          <Button variant="outlined"
                  onClick={onClose}>
            {t("common:cancel")}
          </Button>

          {dupliLoad ?
            <Loading />
            :
            <>
              <Button color="blue"
                      onClick={() => duplicateWo()}>
                {t("admin:buttons:duplicate")}
              </Button>
            </>
          }
        </CardFooter>
      </Card>
    </Modal>
  );
}
/***/
